<template>
  <div class="system-map">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm">
      <el-form-item label="地区：">
        <el-select v-model="placeData[0]" :disabled="dis[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
          <el-option v-for="x in province" :key="x.id" :label="x.name" :value="x.id"></el-option>
        </el-select>
        <el-select v-model="placeData[1]" :disabled="dis[1]" clearable @change="remoteMethod($event,2)" placeholder="市">
          <el-option v-for="x in city" :key="x.id" :label="x.name" :value="x.id"></el-option>
        </el-select><br />
        <el-select v-model="placeData[2]" :disabled="dis[2]" clearable @change="remoteMethod($event,3)" placeholder="县">
          <el-option v-for="x in county" :key="x.id" :label="x.name" :value="x.id"></el-option>
        </el-select>
        <el-select style="margin:10px 0 0 0" v-model="placeData[3]" :disabled="dis[3]" clearable @change="remoteMethod($event,4)" placeholder="镇">
          <el-option v-for="x in town" :key="x.id" :label="x.name" :value="x.id"></el-option>
        </el-select><br />
        <el-select style="margin:10px 0 0 0" v-model="placeData[4]" :disabled="dis[4]" clearable @change="remoteMethod($event,5)" placeholder="村">
          <el-option v-for="x in village" :key="x.id" :label="x.name" :value="x.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="培训模板：">
        <div style="color:red;" v-if="this.isTrainingId.length<1">请先上传模板</div>

        <div v-else v-for="(x, i) in this.isTrainingId" :key="i" style="display:flex;">
          <p style="margin-right:20px;">{{x}}</p>
          <el-button type="primary" :disabled="isTrainingId == ''" @click="getFile(x)">下&nbsp;&nbsp;&nbsp;载</el-button>
        </div>

      </el-form-item>
      <el-form-item label="培训标题：" prop="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="培训备注：" prop="remark">
        <el-input v-model="ruleForm.remark"></el-input>
      </el-form-item>
      <el-form-item label="培训文件：">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :on-success="success"
          accept="application/vnd.ms-excel, MS Excel Spreadsheet, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          :before-upload="beforeAvatarUpload"
          :limit="1"
          :on-remove="handleRemove"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只支持上传excle或word文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="isTrainingId == ''" @click="submit()">提&nbsp;&nbsp;&nbsp;交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    return {
      uploadUrl: `${this.$api.imgUrl}/user/upload`,
      ruleForm: {
        fileId: '',
        title: '',
        remark: ''
      },
      fileList: [],
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }]
      },
      placeData: [],
      dis: [],
      isTrainingId: []
    }
  },
  methods: {
    submit() {
      let place = []
      //过滤空字符串
      place = this.placeData.filter(x => x)
      let province, city, county, town, village
      let arr = []
      let areaArrs = [this.province, this.city, this.county, this.town, this.village]
      place.forEach((i, index) => {
        areaArrs[index].forEach(x => {
          if (x.id === i.areaId) { arr[index] = x.name }
        })
      })
      // console.log(arr)
      province = arr[0]
      city = arr[1]
      county = arr[2]
      town = arr[3]
      village = arr[4]
      // console.log(place)
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (place.length == 0) {
            this.$message.info("请至少选择一个地区")
          } else if (this.ruleForm.trainingId === '') {
            this.$message.info("请上传文件")
          } else {
            // this.ruleForm.id = place[place.length-1]
            this.$api.createStudy({ ...this.ruleForm, province, city, county, town, village }).then(res => {
              if (res.data.status === 0) {
                this.$message.success("提交申请成功")
              } else{ this._status(res.data) }
            })
          }
        } else { return false }
      })
    },
    //上传成功
    success(response, file, fileList) {
      console.log('%cfileList:', 'color: #0ff;', fileList)
      let arr = []
      fileList.forEach(x => {
        x.response.status === 0 ? arr.push(x.response.data) : ''
      })
      arr.length > 0 ? this.ruleForm.fileId = arr.join(',') : ''
    },
    handleRemove(file, fileList) {
      let arr = []
      fileList.forEach(x => {
        x.response.status === 0 ? arr.push(x.response.data) : ''
      })
      arr.length > 0 ? this.ruleForm.fileId = arr.join(',') : ''
    },
    beforeAvatarUpload(file) {
      const arr = [
        "application/vnd.ms-excel",
        "MS Excel Spreadsheet",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ]

      let isNeed = arr.indexOf(file.type) === -1 ? false : true

      if (!isNeed) {
        this.$message.error("请上传excle或word文件")
      }
      return isNeed
    },
    //下载文件
    getFile(id) {
      this.$api.download_doc(id)
    },
    afterAreaGet(areaId) {
      this.$api.getSystem(areaId).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(_R)
          // _R.trainingId ? this.isTrainingId = _R.trainingId.split(',') : ''
          _R.trainingId ? this.isTrainingId = _R.trainingId.split(',') : ''
        } else{ this._status(res.data) }
      })
    },
  },
  created() {
    this.areaGet({ value: { areaId: 0 }, key: 0 })
    let trainingId = window.sessionStorage.getItem('trainingId')
    // this.isTrainingId = trainingId ? trainingId.split(',') : []
    if (trainingId) {
      this.isTrainingId = trainingId.split(',')
    } else if (!this.userInfo.admin) {
      this.$api.getFather({ areaId: this.userInfo.areaId }).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)

          if (_R.length > 1 && _R[_R.length - 2].id) {
            this.$api.getSystem(_R[_R.length - 2].id).then(res2 => {
              if (res2.data.status === 0) {
                let _R2 = JSON.parse(res2.data.data)
                if (_R2.trainingId) {
                  this.isTrainingId = _R2.trainingId.split(',')
                } else {

                  if (_R.length > 2 && _R[_R.length - 3].id) {
                    this.$api.getSystem(_R[_R.length - 3].id).then(res3 => {
                      if (res3.data.status === 0) {
                        let _R3 = JSON.parse(res3.data.data)
                        if (_R3.trainingId) {
                          this.isTrainingId = _R3.trainingId.split(',')
                        } else {

                          if (_R.length > 3 && _R[_R.length - 4].id) {
                            this.$api.getSystem(_R[_R.length - 4].id).then(res4 => {
                              if (res4.data.status === 0) {
                                let _R4 = JSON.parse(res4.data.data)
                                if (_R4.trainingId) {
                                  this.isTrainingId = _R4.trainingId.split(',')
                                } else {

                                  if (_R.length > 4 && _R[_R.length - 5].id) {
                                    this.$api.getSystem(_R[_R.length - 5].id).then(res5 => {
                                      if (res5.data.status === 0) {
                                        let _R5 = JSON.parse(res5.data.data)
                                        if (_R5.trainingId) {
                                          this.isTrainingId = _R5.trainingId.split(',')
                                        } else { this.isTrainingId = [] }
                                      } else{ this._status(res5.data) }
                                    })
                                  } else { this.isTrainingId = [] }

                                }
                              } else{ this._status(res4.data) }
                            })
                          } else { this.isTrainingId = [] }

                        }
                      } else{ this._status(res3.data) }
                    })
                  } else { this.isTrainingId = [] }

                }
              } else{ this._status(res2.data) }
            })
          } else { this.isTrainingId = [] }

        } else { this._status(res.data) }
      })
    }
    // console.log('%cthis.isTrainingId:', 'color: #0ff;', this.isTrainingId)
    this.userInfo.admin ? '' : this.getDefault()
  }
}
</script>

<style scoped>
.system-map {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 180px;
  display: block;
}

.el-textarea .el-textarea__inner {
  resize: none !important;
}
.shangchuan {
  border: 1px dashed #d9d9d9 !important;
  width: 300px;
  height: 180px;
}
</style>
